import { INPUT_MIN_HEIGHT_PX, Media, UI } from '@cowprotocol/ui'

import { transparentize } from 'color2k'
import styled from 'styled-components/macro'

export const InputLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const CustomInput = styled.input`
  --minHeight: ${INPUT_MIN_HEIGHT_PX}px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 22px;
  font-weight: 500;
  border-radius: 16px;
  width: 100%;
  min-height: var(--minHeight);
  border: 1px solid transparent;
  color: inherit;
  padding: 10px 40px 10px 16px;
  background: var(${UI.COLOR_PAPER_DARKER});

  ${Media.upToSmall()} {
    font-size: 20px;
  }

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 12px;
    cursor: pointer;
    filter: ${({ theme }) => (theme.darkMode ? 'invert(1)' : 'invert(0)')};
  }

  &::-webkit-datetime-edit {
    color: inherit;
  }

  &::-webkit-datetime-edit[disabled] {
    color: ${({ theme }) => transparentize(theme.text, 0.7)};
  }
`

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.error};
  font-size: 14px;
`
